var map = {
	"./banner-carousel.de-CH.json": 1160,
	"./banner-carousel.de-DE.json": 1161,
	"./banner-carousel.en-CA.json": 1162,
	"./banner-carousel.en-GB.json": 1163,
	"./banner-carousel.en-IN.json": 1164,
	"./banner-carousel.en-ME.json": 1165,
	"./banner-carousel.en-US.json": 1166,
	"./banner-carousel.es-EM.json": 1167,
	"./banner-carousel.es-ES.json": 1168,
	"./banner-carousel.fr-BE.json": 1169,
	"./banner-carousel.fr-CA.json": 1170,
	"./banner-carousel.fr-CH.json": 1171,
	"./banner-carousel.nl-BE.json": 1172,
	"./banner-carousel.nl-NL.json": 1173,
	"./banner-carousel.pl-PL.json": 1174,
	"./banner-carousel.pt-BR.json": 1175
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1159;